package ru.it_mozaika.sender.js.application.components.campaigns


import js.core.jso
import kotlinx.datetime.*
import mui.material.*
import mui.material.styles.Theme
import mui.system.SxProps
import mui.system.sx
import muix.pickers.*
import react.FC
import react.Props
import react.ReactNode
import react.create
import react.useEffect
import react.useState
import ru.it_mozaika.sender.js.application.moment
import web.cssom.Display
import web.cssom.None
import web.cssom.px

external interface EmailCampaignStartParametersProps : Props {
    var disabled: Boolean
    var startTime: Instant?
    var startTimeChanged: (Instant?) -> Unit
    var intelligentSending: Boolean
    var intelligentSendingChanged: (Boolean) -> Unit
}
val EmailCampaignStartParameters = FC<EmailCampaignStartParametersProps> { props ->
    var delayed by useState(false)
    useEffect(props.startTime) { delayed = props.startTime != null }
    val (invalidDate, setInvalidDate) = useState(false)

    FormControlLabel {
        control = Checkbox.create()
        checked = delayed
        label = ReactNode("Использовать отложенную отправку")
        disabled = props.disabled
        onChange = { _, v ->
            props.startTimeChanged(if (v) {
                Clock.System.now()
            } else {
                null
            })
        }
    }
    FormControlLabel {
        sx { display = if (delayed) Display.block else None.none }
        control = Checkbox.create()
        label = ReactNode("Отправить в течении 24 часов")
        disabled = props.disabled
        checked = props.intelligentSending
        onChange = { _, v ->
            props.intelligentSendingChanged(v)
        }
    }
    LocalizationProvider {
        dateAdapter = AdapterMoment
        adapterLocale = "ru"
            DateTimePicker {
                asDynamic().sx = jso<SxProps<Theme>> {
                    marginTop = 16.px
                    display = if (delayed) Display.block else None.none
                }
                asDynamic().slotProps = jso{
                    textField = jso<TextFieldProps>{
                        fullWidth = true
                    }
                }
                asDynamic().timezone = ReactNode("system")
                asDynamic().disabled = props.disabled
                asDynamic().label = ReactNode("Время отправки")
                asDynamic().value = moment(props.startTime?.toJSDate()) ?: moment()
                asDynamic().onChange = { newValue: dynamic ->
                    if (newValue.toString() == "Invalid date" || newValue == None.none) {
                        setInvalidDate(true)
                    } else {
                        setInvalidDate(false)
                        val localDate = LocalDateTime(
                            newValue.year() as Int,
                            (newValue.month() as Int) + 1,
                            newValue.date() as Int,
                            newValue.hour() as Int,
                            newValue.minute() as Int,
                            newValue.second() as Int
                        )
                        props.startTimeChanged(localDate.toInstant(TimeZone.currentSystemDefault()))
                    }
                }
            }
    }
}